module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_3016.490ba12f.png";